module.exports = __webpack_public_path__ + "static/media/team.f47014b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/team.jpg
// module id = 181
// module chunks = 0